import React from 'react';
import { AlertCircle, Clock, CheckCircle } from 'lucide-react';

interface StatusBadgeProps {
  status: 'awaiting_bids' | 'bidding_in_progress' | 'bidding_complete' | 'no_bids';
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = {
    awaiting_bids: {
      icon: AlertCircle,
      text: 'Awaiting Bids',
      className: 'bg-blue-100 text-blue-800'
    },
    bidding_in_progress: {
      icon: Clock,
      text: 'Bidding in Progress',
      className: 'bg-yellow-100 text-yellow-800'
    },
    bidding_complete: {
      icon: CheckCircle,
      text: 'Bidding Complete',
      className: 'bg-green-100 text-green-800'
    },
    no_bids: {
      icon: AlertCircle,
      text: 'No Bids',
      className: 'bg-red-100 text-red-800'
    }
  };

  const { icon: Icon, text, className } = config[status];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
      <Icon className="w-3 h-3 mr-1" />
      {text}
    </span>
  );
}